/**
 * Shared image preview hook + modal for harvest monitoring reports.
 * Used by both the per-location and per-foreman tables.
 */

import React, { useState } from 'react';
import {
    Image,
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    useDisclosure,
} from '@chakra-ui/react';

export const useImagePreview = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [previewImageUrl, setPreviewImageUrl] = useState<string>('');
    const [previewImageTitle, setPreviewImageTitle] = useState<string>('');

    const handlePreviewImage = (imagePath: string | undefined, title: string) => {
        if (!imagePath) return;
        setPreviewImageUrl(imagePath);
        setPreviewImageTitle(title);
        onOpen();
    };

    return { isOpen, onClose, previewImageUrl, previewImageTitle, handlePreviewImage };
};

interface ImagePreviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    previewImageUrl: string;
    previewImageTitle: string;
}

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
    isOpen,
    onClose,
    previewImageUrl,
    previewImageTitle,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent borderRadius="lg" overflow="hidden" maxW="90vw" w="fit-content" mx={4}>
                <ModalHeader bg="customGold.500" color="white" pr={12} fontSize="xl">
                    {previewImageTitle}
                </ModalHeader>
                <ModalCloseButton color="black" />
                <ModalBody display="flex" justifyContent="center" alignItems="center" p={6}>
                    {previewImageUrl ? (
                        <Image
                            src={previewImageUrl}
                            alt={previewImageTitle}
                            maxW="100%"
                            maxH="70vh"
                            objectFit="contain"
                            borderRadius="lg"
                        />
                    ) : (
                        <Text>Gambar tidak tersedia</Text>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
